export default __webpack_public_path__ + "static/media/Assets.4831e4e9.png";